import { render, staticRenderFns } from "./data-view.vue?vue&type=template&id=28870186&"
import script from "./data-view.vue?vue&type=script&lang=js&"
export * from "./data-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../rewards-admin-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports